import { TileCoordinates } from "../../lib/runescape/coordinates";
import { direction, MovementAbilities } from "../../lib/runescape/movement";
import { Vector2 } from "../../lib/math";
var dive_internal = MovementAbilities.dive_internal;
import { util } from "../../lib/util/util";
import { HostedMapCollisionData } from "../../lib/runescape/CollisionData";
export function withoutFirst(array, value) {
    const index = array.indexOf(value);
    return index === -1
        ? array
        : array.slice(0, index).concat(array.slice(index + 1));
}
export function distinct(array) {
    return Array.from(new Set(array));
}
export var PathFindingLite;
(function (PathFindingLite) {
    var asyncFilter = util.asyncFilter;
    function group(raw) {
        const grouped = [];
        raw.forEach(path => {
            const group = grouped.find(g => TileCoordinates.eq(g.origin, path.origin));
            if (!group)
                grouped.push({ origin: path.origin, paths: [path] });
            else {
                if (group.paths[0].path.length > path.path.length)
                    group.paths = [path];
                else if (group.paths[0].path.length == path.path.length)
                    group.paths.push(path);
            }
        });
        return grouped.filter(g => g.paths[0].path.length > 0);
    }
    PathFindingLite.group = group;
    async function litePathFindingImplementation(target, abilities) {
        if (abilities.length == 0)
            return [[]];
        const possible_origins = await (async () => {
            return (await Promise.all(distinct(abilities).map(async (ability) => {
                const rest = withoutFirst(abilities, ability);
                //.filter(rest_abil => !(ability == "surge" && rest_abil == "escape" || ability == "escape" && rest_abil == "surge"))
                const origins = await (async () => {
                    switch (ability) {
                        case "surge":
                        case "escape":
                        case "dive": {
                            const target_directions = target.direction ? [target.direction] : direction.all;
                            const distance = ability == "escape" ? 7 : -10;
                            return (await Promise.all(target_directions.map(async (dir) => {
                                const from = {
                                    direction: ability == "dive" ? undefined : dir,
                                    tile: TileCoordinates.move(target.tile, Vector2.scale(distance, direction.toVector(dir)))
                                };
                                const arrival = await dive_internal(HostedMapCollisionData.get(), from.tile, target.tile);
                                if (arrival && TileCoordinates.eq(target.tile, arrival.tile))
                                    return from;
                                return null;
                            }))).filter(v => v);
                        }
                    }
                    return [];
                })();
                return origins.map(o => ({ pos: o, rest, ability: ability }));
            }))).flat();
        })();
        return [...(await Promise.all(possible_origins.map(async ({ pos, rest, ability }) => {
                const step = {
                    type: "ability",
                    ability: ability,
                    from: pos.tile,
                    to: target.tile,
                    is_far_dive: ability == "dive" ? true : undefined
                };
                const recur = await litePathFindingImplementation(pos, rest);
                return recur.map(r => [...r, step]);
            }))).flat(), []];
    }
    async function litePathFinding(target, ability_combinations) {
        if (!target)
            debugger;
        const raw = (await Promise.all(ability_combinations.flatMap(comb => target.map(async (t) => await litePathFindingImplementation(t, comb).then(paths => paths.map(p => ({
            origin: p?.[0]?.from ?? t.tile,
            path: p
        }))))))).flat();
        return asyncFilter(group(raw), g => HostedMapCollisionData.get().isAccessible(g.origin));
    }
    PathFindingLite.litePathFinding = litePathFinding;
})(PathFindingLite || (PathFindingLite = {}));
